import { useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/material";

export interface IBreakpoint {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
}

export const useColumnVisibilityHook = (tableHeadersUpdated: any[]) => {
  const theme = useTheme();
  const breakpoints: IBreakpoint = {
    xs: !useMediaQuery(theme.breakpoints.down("xs")),
    sm: !useMediaQuery(theme.breakpoints.down("sm")),
    md: !useMediaQuery(theme.breakpoints.down("md")),
    lg: !useMediaQuery(theme.breakpoints.down("lg")),
    xl: !useMediaQuery(theme.breakpoints.down("xl")),
  };

  return tableHeadersUpdated.reduce(
    (prev, value) => ({
      ...prev,
      [value["field"]]:
        breakpoints[value["hideOnBreakpoint"] as keyof IBreakpoint],
    }),
    {}
  );
};
